import { queue } from "@/components/Toast";
import { isReminderCooldown, useRemindClient } from "../content-calendar/review/useClientRoundActions";

/**
 * Remind on a Needs-you send: the calendar's own reminder (POST
 * plans/:planId/remind), optimistic there. Inside the one-day cooldown the
 * server answers 409; the toast offers to send anyway.
 */
export default function RemindButton({
  className,
  planId,
  round,
  roundId,
  label,
}: {
  className: string;
  planId: string;
  round: "concept" | "brief";
  roundId: string;
  label: string;
}) {
  const remind = useRemindClient(planId);
  const send = (force = false) =>
    remind.mutate(
      { slotId: "", kind: round, roundId, force },
      {
        onError: (err) => {
          const message = isReminderCooldown(err);
          if (!message) return;
          queue.add({
            title: message,
            variant: "info",
            action: { label: "Send anyway", onPress: () => send(true) },
          });
        },
      },
    );
  return (
    <button type="button" className={className} onClick={() => send()} disabled={remind.isPending}>
      {label}
    </button>
  );
}
